<template>
  <div v-if="permissoes.editar_configuracoes || permissoes.ler_configuracoes">
    <!-- Breadcrumb e Cabeçalho -->
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Negócio Custo Mão de Obra</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <!-- Título -->
    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Negócio Custo Mão de Obra</h1>
      </el-col>
    </el-row>
    <!-- Botão Novo -->
    <el-row type="flex" style="text-align: left; margin-bottom: 10px;">
      <el-col :span="24">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          v-if="permissoes.editar_configuracoes"
          @click="formMaoObraOpen()"
        >Novo</el-button>
      </el-col>
    </el-row>
    <!-- Tabela -->
    <el-row type="flex" justify="start" aling="left">
      <el-col :span="24">
        <el-table
          :data="MaoObras"
          style="width: 100%"
          v-loading="loading"
          element-loading-text="Loading..."
        >
          <el-table-column prop="funcao" label="Função" min-width="300" sortable></el-table-column>
          <el-table-column prop="valor_hora" label="Valor Hora" width="150" align="right"></el-table-column>
          <el-table-column label="Ação" width="200">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="formMaoObraOpen(scope.row)">Editar</el-button>
              <el-button
                v-if="permissoes.excluir_contatos"
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="deleteMaoObra(scope.row)"
              >Excluir</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  
    <!-- Formulário -->
    <el-dialog
      :title="formDataMaoObra.id ? 'Editar Mão de Obra' : 'Nova Mão de Obra'"
      :visible.sync="formMaoObraVisible"
      :show-close="false"
    >
      <el-form 
        :model="formDataMaoObra" 
        :rules="rules" 
        ref="formMaoObra" 
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="Função" prop="funcao">
          <el-input v-model="formDataMaoObra.funcao" />
        </el-form-item>
        <el-form-item label="Valor Hora" prop="valor_hora">
          <el-input v-model="formDataMaoObra.valor_hora" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="formMaoObraClose()">Cancelar</el-button>
        <el-button type="primary" @click="submitMaoObra()">Salvar</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>

import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

const url = "/api";

export default {

  data() {
    return {
      loading: true,
      formMaoObraVisible: false,
      permissoes: {},
      MaoObras: [],
      formDataMaoObra: {},
      rules: {
        funcao: [
          { required: true, message: "Por Favor, informe a Função", trigger: "blur" },
        ],
        valor_hora: [
          { required: true, message: "Por Favor, informe o Valor Hora", trigger: "blur" },
        ],
      },
    };
  },

  mounted() {
    this.permissoes = FuncoesUteis.isPermissao();
    if (!this.permissoes.ler_configuracoes) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.buscarMaoObras();
  },

  methods: {

    async buscarMaoObras() {
      try {
        this.loading = true;
        const response = await axios.get(url + '/orcamento/negocio/custo-mao-obra/', {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.MaoObras = response.data;
        }
      } catch (error) {
        this.$message.error('Erro ao buscar Mão de Obra: ' + error.message);
      } finally {
        this.loading = false;
      }
    },

    formMaoObraOpen(row = null) {
      if (row) {
        this.formDataMaoObra = { ...row };
      } else {
          this.formDataMaoObra = { 
            id: null,
            funcao: null,
            valor_hora: null,
          };
      }
      this.formMaoObraVisible = true;
    },

    formMaoObraClose() {
      this.$confirm("Deseja fechar sem salvar?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.formMaoObraVisible = false;
        })
        .catch(() => {});
    },

    submitMaoObra() {
      this.$refs.formMaoObra.validate((valid) => {
        if (!valid) {
          this.$message.info("Preencha os dados corretamente!");
          return;
        }

        const headers = { Authorization: "Bearer " + this.$store.state.token };
        const payload = { ...this.formDataMaoObra };
        const request = this.formDataMaoObra.id
          ? axios.put(`${url}/orcamento/negocio/custo-mao-obra/${this.formDataMaoObra.id}`, payload, { headers })
          : axios.post(`${url}/orcamento/negocio/custo-mao-obra/`, payload, { headers });

        request
          .then(() => {
            this.$notify({
              title: "Sucesso",
              message: this.formDataMaoObra.id ? "Registro atualizado!" : "Registro criado!",
              type: "success",
            });
            this.formMaoObraVisible = false;
            this.buscarMaoObras();
          })
          .catch((err) => {
            this.$notify({
              title: "Erro",
              message: "Falha ao salvar os dados. " + err,
              type: "error",
            });
          });
      });
    },

    deleteMaoObra(row) {
      this.$confirm("Deseja excluir este registro?", "Confirmação", {
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(`${url}/orcamento/negocio/custo-mao-obra/${row.id}`, {
              headers: { Authorization: "Bearer " + this.$store.state.token },
            })
            .then(() => {
              this.$notify({ title: "Sucesso", message: "Registro excluído!", type: "success" });
              this.buscarMaoObras();
            })
            .catch((err) => {
              this.$notify({ title: "Erro", message: "Falha ao excluir. " + err, type: "error" });
            });
        })
        .catch(() => {});
    },
  },

};

</script>

<style scoped>
  .item {
    margin:0;
  }
</style>
